/* import __COLOCATED_TEMPLATE__ from './topic-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    topicType: string;
    topicName: string;
    hideTopicType?: boolean;
    small?: boolean;
  };
}

const TopicStamp = templateOnlyComponent<Signature>();
export default TopicStamp;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TopicTrends::TopicStamp': typeof TopicStamp;
  }
}
